import React from "react";
import { ProductDraftContentBarcode } from "../../../../../lib/interface/InterfaceProduct";

export default function ProductEditContentBarcodeEditor({
  value,
  onChange,
}: {
  value: ProductDraftContentBarcode[];
  onChange: (v: ProductDraftContentBarcode[]) => void;
}) {
  return (
    <div className="table-responsive">
      <table className="table table-striped table-bordered">
        <thead>
          <tr>
            <th>Color</th>
            <td>Size</td>
            <td>Barcode</td>
          </tr>
        </thead>
        <tbody>
          {value.map((x, idx) => {
            return (
              <tr key={idx}>
                <td>{x.color}</td>
                <td>{x.size}</td>
                <td>
                  <input
                    type="text"
                    placeholder="Enter barcode"
                    value={x.barcode}
                    className="form-transparent"
                    onChange={(e) => {
                      const tmp = [...value];
                      tmp[idx] = {
                        barcode: e.currentTarget.value,
                        color: x.color,
                        size: x.size,
                      };
                      onChange(tmp);
                    }}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
